import { Component, State, h } from '@stencil/core';

@Component({
  tag: 'qumra-coupon',
  styleUrl: 'qumra-coupon.css',
  shadow: true,
})
export class QumraCoupon {
  @State() loading: boolean = false;
  @State() coupon: string = '';
  @State() getCoupon: boolean = false;
  
  async addCoupon() {
    this.loading = true;
    window.Qumra.cart.redeemCode(this.coupon).finally(() => {
      this.loading = false;
    });
  }

  handelCouponChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.coupon = input.value; 
  }

  render() {
    return (
      <div>
        <div class="coupon-container">
          <input
          disabled={this.loading || this.getCoupon}
            onInput={(event) => this.handelCouponChange(event)} 
            placeholder="أدخل كود الخصم"
            class="coupon-input"
            type="text"
            aria-label="حقل إدخال كود الخصم"
          />
          <button
            onClick={() => this.addCoupon()}
            class="coupon-button"
            aria-label="UICoupon-button"
            type="button"
            style={{ backgroundColor: this.getCoupon &&'#D9D9D9'  }}
            disabled={this.loading || this.getCoupon}
          >
            {this.loading ? <qumra-loading color={"white"} loading-size="20px" loading={this.loading}></qumra-loading> :'تطبيق'}
          </button>
        </div>
       
        </div>
    );
  }
}
